import { ReadField } from 'components/ReadField';
import {
    OtherCostCalculationTypeEnum,
    type BimContractOtherCostBaseData,
    type ContractOtherCostBaseData,
} from 'gql/graphql';
import { Grid, GridItem } from 'uikit';

import { useConstructionTypesListItems } from '../../pages/Project/Common/hooks/useConstructionTypesListItems';
import { getOtherMethod } from '../EditOtherForm/EditOtherCommon';

import Styles from './EditOtherDistribution.module.css';

export const EditOtherDistributionCommon = ({
    workOrderCommonData,
    currentConstructionTypeId,
    isCalculating,
    isUer,
    isBim,
    bimWorkOrderOtherCommonData,
}: {
    isUer: boolean;
    isBim: boolean;
    currentConstructionTypeId?: number;
    isCalculating?: boolean;
    workOrderCommonData?: ContractOtherCostBaseData | null;
    bimWorkOrderOtherCommonData?: BimContractOtherCostBaseData | null;
}) => {
    const { getConstructionTypeName } = useConstructionTypesListItems();

    const methodUer = getOtherMethod({
        isGlobal: workOrderCommonData?.isGlobalOtherCost,
        status: workOrderCommonData?.status,
    });

    const methodBim = getOtherMethod({
        isGlobal: bimWorkOrderOtherCommonData?.isGlobalOtherCost,
        status: bimWorkOrderOtherCommonData?.status,
    });

    const chapterValue =
        workOrderCommonData?.chapter || bimWorkOrderOtherCommonData?.chapter === 'CHAPTER9'
            ? 'Глава 9'
            : 'Раздел "Лимиты Заказчика"';

    const isCalculatingTypePercent =
        bimWorkOrderOtherCommonData?.calculatingType === OtherCostCalculationTypeEnum.Percent;
    const bimCalculatingTypeText = isCalculatingTypePercent ? '%' : 'Расчет';

    return (
        <Grid>
            <GridItem className={Styles.negativeM}>
                <ReadField value={isUer ? methodUer : methodBim} label="Способ создания" />
            </GridItem>
            <GridItem className={Styles.negativeM}>
                <ReadField
                    value={isUer ? workOrderCommonData?.name : bimWorkOrderOtherCommonData?.name}
                    label="Наименование"
                />
            </GridItem>
            {isUer && (
                <GridItem className={Styles.negativeM}>
                    <ReadField value={workOrderCommonData?.key} label="Код" />
                </GridItem>
            )}
            <GridItem className={Styles.negativeM}>
                {isUer && (
                    <ReadField
                        value={isCalculating ? 'Расчет' : `${workOrderCommonData?.calculatingTypeValue} %`}
                        label="Способ расчета"
                    />
                )}
                {isBim && <ReadField value={bimCalculatingTypeText} label="Способ расчета" />}
            </GridItem>
            {isBim && isCalculatingTypePercent && (
                <GridItem className={Styles.negativeM}>
                    <ReadField value={bimWorkOrderOtherCommonData?.calculatingTypeValue} label="Величина" />
                </GridItem>
            )}
            <GridItem className={Styles.negativeM}>
                <ReadField value={chapterValue} label="Раздел" />
            </GridItem>
            <GridItem className={Styles.negativeM}>
                <ReadField value={getConstructionTypeName(currentConstructionTypeId)} label="Вид строительства" />
            </GridItem>
        </Grid>
    );
};

EditOtherDistributionCommon.displayName = 'EditOtherDistributionCommon';
